import { render, staticRenderFns } from "./WfhDayCard.vue?vue&type=template&id=b0ab9978"
import script from "./WfhDayCard.vue?vue&type=script&lang=js"
export * from "./WfhDayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports